export type LanguageCode = 'en' | 'nl' | 'de';

type Language = {
	code: LanguageCode;
	file: `${LanguageCode}.ts`;
};

const languages: Language[] = [
	{
		code: 'en',
		file: 'en.ts',
	},
	{
		code: 'nl',
		file: 'nl.ts',
	},
	{
		code: 'de',
		file: 'de.ts',
	},
];

export default languages;
